import React from "react";
import { useColumnResizeContext } from "../../context/ColumnResizeContext";
import ResizeHandle from "./ResizeHandle";

/**
 * Wrapper para uma celula de cabecalho (Th) que adiciona a alca de
 * redimensionamento na borda direita.
 *
 * Uso com qualquer componente Th existente via prop `as`:
 *
 *   <ResizableTh as={Th} columnKey="cliente">Cliente</ResizableTh>
 *
 * O Th original precisa ter `position: relative` ou `sticky` para que
 * a alca (posicionada `absolute`) se ancore corretamente.
 *
 * Se a coluna nao deve ser redimensionavel, passe `resizable={false}` —
 * a celula renderiza normalmente sem alca.
 */
export default function ResizableTh({
  as: As = "th",
  columnKey,
  resizable = true,
  style,
  children,
  ...rest
}) {
  const ctx = useColumnResizeContext();

  if (!ctx || !columnKey) {
    return (
      <As style={style} {...rest}>
        {children}
      </As>
    );
  }

  const width = ctx.widths[columnKey];
  const styleFinal = {
    ...(style || {}),
    ...(width ? { width } : {}),
    // Bugfix #13 fix v4 (2026-05-29): NAO setar `position: relative`
    // inline. Antes, isso sobrescrevia o `position: sticky` aplicado
    // via styled-component no Th, e como o CSS sticky tambem aplica
    // `top: var(--app-header-height)`, o th ficava em position:relative
    // com top:56px — deslocado 56px pra BAIXO da posicao natural.
    // Resultado: 1 linha de dados aparecia ACIMA do cabecalho.
    // ResizeHandle (filho absolute) funciona com ancestral sticky
    // tambem — sticky eh "positioned" para fins de ancoragem.
  };

  return (
    <As style={styleFinal} {...rest}>
      {children}
      {resizable && (
        <ResizeHandle
          onPointerDown={(e) => ctx.startResize(columnKey, e)}
          onDoubleClick={() => ctx.resetColumn(columnKey)}
        />
      )}
    </As>
  );
}
